// extracted by mini-css-extract-plugin
module.exports = {"divider":"ProgramSummary_divider__2mup1","title":"ProgramSummary_title__1bjre","spacer":"ProgramSummary_spacer__10ca7","rightBtnCol":"ProgramSummary_rightBtnCol__1yd62"};